import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = { class: "modal-title" }
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "modal-footer" }
const _hoisted_10 = {
  type: "submit",
  form: "cost-subtotal-editor-form",
  class: "btn btn-primary"
}

import { computed, toRef } from 'vue'

    import { EditorState } from '@common/Common'
    import
        {
            CreateCostSubtotalEventPayload,
            RenameCostSubtotalEventPayload
        } from '@Quest/Costs/Components/CostSubtotalEditor'
    import type { CostSubtotalEditorViewModel } from '@Quest/Costs/Components/CostSubtotalEditor'

    // ---------------- props / emits ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CostSubtotalEditor',
  props: {
    viewModel: {}
  },
  emits: ["create-subtotal", "rename-subtotal"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    // ---------------- shortcuts ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- computed ----------------

    const opened = computed(() => vm.value?.opened ?? false)

    const confirmButtonLabel = computed(() =>
        vm.value.state === EditorState.Creator ? 'Create' : 'Update'
    )

    const modalTitle = computed(() =>
        vm.value.state === EditorState.Creator ? 'Create subtotal' : 'Edit subtotal'
    )

    // writable computed (replaces getter + setter)

    const name = computed<string | null>({
        get: () => vm.value.name,
        set: v => { vm.value.name = v }
    })

    // ---------------- actions ----------------

    function handleFormSubmit()
    {
        if (vm.value.state === EditorState.Creator)
        {
            emit(
                'create-subtotal',
                new CreateCostSubtotalEventPayload(name.value)
            )
        }
        else if (vm.value.state === EditorState.Editor)
        {
            emit(
                'rename-subtotal',
                new RenameCostSubtotalEventPayload(vm.value.id, name.value)
            )
        }
    }

    function close()
    {
        vm.value.close()
    }

return (_ctx: any,_cache: any) => {
  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h5", _hoisted_6, _toDisplayString(modalTitle.value), 1 /* TEXT */),
                _createElementVNode("button", {
                  onClick: close,
                  type: "button",
                  class: "close"
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("form", {
                  id: "cost-subtotal-editor-form",
                  onSubmit: _withModifiers(handleFormSubmit, ["prevent"])
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _cache[1] || (_cache[1] = _createElementVNode("label", null, "Name:", -1 /* CACHED */)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
                      class: "form-control",
                      required: "",
                      maxlength: "100",
                      minlength: "2"
                    }, null, 512 /* NEED_PATCH */), [
                      [
                        _vModelText,
                        name.value,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ])
                ], 32 /* NEED_HYDRATION */)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: close,
                  class: "btn btn-outline-secondary"
                }, "Cancel"),
                _createElementVNode("button", _hoisted_10, _toDisplayString(confirmButtonLabel.value), 1 /* TEXT */)
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})